import styled from 'styled-components';
import { vars, pxToRem, media } from '$util/theme';
import { topBackgroundCss } from '$layout/partials/TopBackground';
import Grid from '$components/layout/Grid';

export const Styled = styled(Grid)`
  ${topBackgroundCss}

  overflow: visible;
  padding-top: 32px;

  ${media.up('md')} {
    padding-top: 48px;
  }
  ${media.up('lg')} {
    padding-top: 54px;
  }

  .top-wrapper {
    text-align: center;
    header {
      h1.title {
        font-size: ${pxToRem(28)};
        font-weight: ${vars.fontWeight.light};
        margin-bottom: 24px;
        ${media.up('md')} {
          margin-bottom: 30px;
          font-size: ${pxToRem(36)};
        }
        ${media.up('lg')} {
          font-size: ${pxToRem(50)};
        }
        > strong {
          font-weight: ${vars.fontWeight.bold};
        }
      }
      h2.title {
        line-height: inherit;
        font-weight: ${vars.fontWeight.light};
        font-size: ${pxToRem(20)};
        ${media.up('md')} {
          font-size: ${pxToRem(24)};
        }
      }
    }
  }

  .search-card {
    margin-top: 20px;
    ${media.down('sm')} {
      background: transparent !important;
      box-shadow: none !important;
      padding: 0;
    }
    ${media.up('md')} {
      max-width: 610px;
      margin: 20px auto 0;
    }
    .text-highlight {
      display: block;
      margin-bottom: 10px;
    }
  }

  .Bottom {
    display: flex;
    justify-content: center;
    align-items: center;

    ${media.down('sm')} {
      overflow: hidden;
    }

    .part-of-renault {
      margin-top: 60px;
      ${media.up('md')} {
        display: flex;
        justify-content: center;
      }
      > .PartOfRenault {
        ${media.down('sm')} {
          justify-content: center;
          margin-top: 20px;
        }
      }
      &.with-path {
        margin-top: 0;
      }
    }
  }
`;
